import { lazyLoad } from 'utils/loadable';

export const OrderDetailsWrapperLoadable = lazyLoad(
  () => import('./OrderDetailsWrapper'),
  module => module.OrderDetailsWrapper,
);
